import { object as YupObject, string as YupString } from "yup";

export default YupObject().shape({
    email: YupString()
    .email("Email is not valid")
    .required("Email is required")
});

